import styled from 'styled-components'

const YearView = styled.div`
  flex-shrink: 0;
  color: ${({theme}) => theme.shell.footer.copyright.brandNameColor || theme.shell.footer.copyright.color};
`

export default YearView
